import { createContext } from 'react';
import { SummaryController } from './types';

// eslint-disable-next-line
export const SummaryContext = createContext<SummaryController | null>(null);

export type SummaryProviderProps = {
  controller: SummaryController;
};

export function SummaryProvider({
  controller,
  ...others
}: React.PropsWithChildren<SummaryProviderProps>) {
  return <SummaryContext.Provider {...others} value={controller} />;
}
